module.exports = __webpack_public_path__ + "assets/img/video-play.6c4ef1f6.png";